import { render, staticRenderFns } from "./NewStateRestrictions.vue?vue&type=template&id=50a8299e&"
import script from "./NewStateRestrictions.vue?vue&type=script&lang=js&"
export * from "./NewStateRestrictions.vue?vue&type=script&lang=js&"
import style0 from "./NewStateRestrictions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports